import { Grid } from "@mui/material";
import { useAppSelector, useCatalogItems } from "../../app/hooks";
import Error from "../common/Error";
import Loading from "../common/Loading";
import { Role } from "../../app/backendTypes";
import { useParams } from "react-router-dom";
import CatalogItem from "./CatalogItem";
import { SetCatalog } from "./SetCatalog";
import CatalogCard from "./CatalogCard";
import { useEffect, useState } from "react";

export default function Catalog() {
  const { catalogItems, loading, error, reload } = useCatalogItems();

  const [filteredCatalogItems, setFilteredCatalogItems] =
    useState(catalogItems);
  const isAdminOrEditor = useAppSelector(
    (state) =>
      state.auth.roles.includes(Role.Administrator) ||
      state.auth.roles.includes(Role.CatalogEditor)
  );
  const userLegalUnitId = useAppSelector(
    (state) => state.auth.workingForLegalUnit
  );

  useEffect(() => {
    const CatalogItemFiltering = (approvedCompaniesIds: number[] | undefined, restrictedCompaniesIds: number[] | undefined) => {
      if (isAdminOrEditor)
        return true;

      if (userLegalUnitId === null)
        return false;

      if (
        (approvedCompaniesIds === undefined || approvedCompaniesIds.length === 0) &&
        (restrictedCompaniesIds === undefined || restrictedCompaniesIds.length === 0)
      )
        return true;

      if (approvedCompaniesIds !== undefined && restrictedCompaniesIds !== undefined)
        return approvedCompaniesIds.includes(userLegalUnitId) && !restrictedCompaniesIds.includes(userLegalUnitId);

      if (restrictedCompaniesIds !== undefined && restrictedCompaniesIds.includes(userLegalUnitId))
        return false;

      if (approvedCompaniesIds !== undefined && approvedCompaniesIds.includes(userLegalUnitId))
        return true;
      return false;
    }
    setFilteredCatalogItems(
      catalogItems.filter(c => CatalogItemFiltering(c.company_permissions?.approved_ids, c.company_permissions?.restricted_ids))
    );

  }, [catalogItems, userLegalUnitId, isAdminOrEditor]);

  const params = useParams();
  const item = catalogItems.find((c) => c.id === params.id);

  if (loading) return <Loading />;
  if (error) return <Error error={error} />;

  if (item !== undefined)
    return (
      <CatalogItem
        item={item}
        callback={reload}
        isAdminOrEditor={isAdminOrEditor}
      />
    );
  return (
    <>
      {isAdminOrEditor && <SetCatalog callback={reload} />}

      <Grid container spacing={4} justifyContent="center">
        {filteredCatalogItems.map((catalog_item, i) => (
          <Grid key={i} size="auto">
            <CatalogCard catalog={catalog_item} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

